const { dataLayer } = window;

const isDataLayerLoaded = !!dataLayer && !!dataLayer.push;

const push = process.env.NODE_ENV !== 'development' && isDataLayerLoaded
  ? dataLayer.push
  // eslint-disable-next-line no-console
  : payload => console.log('GTM dataLayer#push is loaded:', isDataLayerLoaded, 'Payload:', payload);

export default push;



// WEBPACK FOOTER //
// ./src/services/dataLayer.js